import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/index.css";
import { Box, Typography, Button } from "@mui/material";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import PaymentIcon from "@mui/icons-material/Payment";
import usePageMeta from "../../utils/usePageMeta";
import BASE_URL from "../config/appconfig";

const Payment = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/admin/check-payment-status`, {
          method: "GET",
        });
        if (!res.ok) return;
        const data = await res.json();
        if (data.payment_status === "verified") {
          clearInterval(interval);
          if (data.nextStep === "assessment") {
            navigate("/assessment", {
              state: { assessmentId: data.assessmentId },
              replace: true,
            });
          } else {
            navigate("/verification", { replace: true });
          }
        }
      } catch (_) {}
    };

    checkStatus();
    const interval = setInterval(checkStatus, 15000);

    return () => clearInterval(interval);
  }, [navigate]);

  usePageMeta(
    "Payment",
    "Complete your payment to access the Gospel and Church Health Framework.",
  );
  return (
    <Box className="verification-container">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h2" className="verification-title1">
          Complete Your Payment
        </Typography>
        <Typography variant="h6" className="verification-title-payment">
          Secure The Gospel and Church Health Framework Access
        </Typography>
        <Typography variant="body1" className="verification-subtitle">
          Finalize your registration for The Gospel and Church Health Framework.
          One-time payment grants full access to the diagnostic tool and
          resources.
        </Typography>
      </Box>

      {/* Payment Amount Section */}
      <Box
        sx={{
          backgroundColor: "#f8f9fa",
          borderRadius: "12px",
          p: 4,
          mb: 4,
          textAlign: "center",
        }}
      >
        {" "}
        <Typography
          variant="h4"
          sx={{ color: "#ED1C2E", fontWeight: "bold", mb: 1 }}
        >
          US$75
        </Typography>
        <Button
          variant="contained"
          onClick={() => {
            const storedUser = JSON.parse(localStorage.getItem("userData"));

            if (!storedUser) {
              alert("User session expired. Please log in again.");
              return;
            }

            // redirect to Stripe
            window.location.href =
              "https://buy.stripe.com/4gM7sK5j8cOg5ECcZHa3u00";
          }}
          sx={{
            bgcolor: "#ED1C2E",
            color: "white",
            borderRadius: "10px",
            px: 4,
            py: 1.5,
            textTransform: "none",
            fontWeight: 600,
            fontSize: 16,
            "&:hover": { bgcolor: "#c81a26" },
          }}
          startIcon={<PaymentIcon />}
        >
          Pay Now
        </Button>
        <Typography variant="body1" sx={{ color: "#666", mt: 2 }}>
          *One-time access
        </Typography>
        <Typography variant="subtitle1" className="verification-subtitle1">
          *Payment processed securely via <strong>Stripe</strong>
        </Typography>
      </Box>

      <Box sx={{ textAlign: "center" }}>
        <Button
          variant="outlined"
          onClick={() =>
            window.open(
              "mailto:churchhealth@citytocityasiapacific.com",
              "_blank",
            )
          }
          sx={{
            borderRadius: "10px",
            borderWidth: "1px",
            borderColor: "#8A8F94",
            textTransform: "none",
            height: 40,
            fontSize: 12,
            letterSpacing: 0.8,
            padding: "6px 16px",
            color: "#2A3238",
            lineHeight: 1.5,
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            "&:hover": {
              borderWidth: "1px",
              borderColor: "#2A3238",
              backgroundColor: "transparent",
            },
          }}
        >
          CONTACT CTCAP
          <HeadsetMicOutlinedIcon sx={{ fontSize: 16 }} />
        </Button>
        <Typography
          variant="subtitle1"
          className="verification-subtitle1"
          sx={{ mt: 2 }}
        >
          Need assistance? Contact our team for payment questions or alternative
          options.
        </Typography>
      </Box>
    </Box>
  );
};

export default Payment;
